module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portal-body"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "area"
  }, _vm._l((_vm.areaList), function(area, index) {
    return _c('my-area', {
      key: index,
      attrs: {
        "titleData": area,
        "areaData": _vm.areaData[area.model]
      }
    })
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../../../static/banner.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-5579042a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/page/first/index.vue
// module id = 29
// module chunks = 0